import * as authApiProd from "./auth"
import { authApiMock } from "./mock"
export { useAccessParams } from "./useAccessParams"
export { useAuth } from "./useAuth"

const authApi =
  import.meta.env.MODE === "test" ? authApiMock.mocks : authApiProd

export const auth = authApi
